import { Button, Col, Input, Modal, Radio, Row, Select, Table, message, Form, Divider } from "antd";
import { useEffect, useState } from "react";
import intl from "react-intl-universal";
import { ExclamationCircleFilled } from "@ant-design/icons";
import "./TeamModal.less";
import ErCode from "../../../components/erCode";
import { messageModal } from "@utils/message-modal";
import {
    adRegist,
} from "@services/auth";
import { activateAccount, checkAccount, searchAccount } from "../../../services/auth";

// {/* 团队账号绑定弹窗 */}
export function TeamBindModal(props) {
    const { Option } = Select;

    const { isTeamBindModal, closeModal, loginData } = props;
    const [loading, setLoading] = useState(false); //表格加载效果
    const [isCheckModalVisible, setIsCheckModalVisible] = useState(false);
    const [dataSource, setDataSource] = useState(props.dataSource.adTeamVos ?? []);
    const [currentAccountIndex, setCurrentAccountIndex] = useState();
    const [inputAccount, setInputAccount] = useState();//团队账号
    const [inputTeamName, setInputTeamName] = useState();//团队名称
    const [type, setType] = useState(props.type);//ad、choose、dots、dotsLike、dotsSearch
    const [tipModalType, setTipModalType] = useState();//tips: 提示，check： 校验,checkLike: 模糊查询校验，search: 搜索
    const [nextBtnDisable, setNextBtnDisable] = useState(true);//下一步按钮禁用事件
    const [checkResult, setCheckResult] = useState(true);//校验账号是否通过
    const [noSearchTips, setNoSearchTips] = useState(false);//无搜索结果展示
    const [isRegisterModalVisible, setIsRegisterModalVisible] = useState(false);//注册团队弹窗展示
    const [regFormTeam] = Form.useForm(); // 登录/注册 团队
    const [supplierType, setSupplierType] = useState(3); // 团队类型
    const [isOverseas, setIsOverseas] = useState(1); // 海外团队
    useEffect(() => {
        if (type === 'choose') {
            const data = dataSource;
            data.map((d, i) => {
                if (d.sourceCode === 'DOTS') {
                    d.selected = true;
                    setCurrentAccountIndex(i);
                }
                else {
                    d.selected = false;
                }
            });
            setDataSource([...data]);
        }
    }, []);

    //关联或启用账号切换事件
    const handleChooseEvent = (record, index) => {
        const data = dataSource;
        setCurrentAccountIndex(index);
        if (type === 'choose') {
            data.map(d => {
                if (d.account === record.account && d.id === record.id) {
                    d.selected = true;
                }
                else {
                    d.selected = false;
                }
            });
        }
        else if (type === 'dotsSearch' || !record.searchType || record.verify) {
            data.map(d => {
                if (d.account === record.account && d.id === record.id) {
                    d.checked = true;
                }
                else {
                    d.checked = false;
                }
            });
            if (data.filter(d => d.checked).length === 1) {
                setNextBtnDisable(false);
            }
            else {
                setNextBtnDisable(true);
            }
        }
        else {
            if (data[index].searchType === 2) {
                setIsCheckModalVisible(true);
                setTipModalType('check');
                return;
            }
            if (data[index].searchType === 3) {
                setIsCheckModalVisible(true);
                setTipModalType('checkLike');
                return;
            }
        }
        setDataSource([...data]);
    }

    //ad选择是否，只能一个为是
    const handleAccountChanged = (e, index) => {
        setCurrentAccountIndex(index);
        if (e && dataSource[index].searchType === 2 && !dataSource[index].verify) {
            setIsCheckModalVisible(true);
            setTipModalType('check');
            return;
        }
        else if (e && dataSource[index].searchType === 3 && !dataSource[index].verify) {
            setIsCheckModalVisible(true);
            setTipModalType('checkLike');
            return;
        }
        else {
            const data = dataSource;
            data[index].checked = e;
            if (type === "ad") {
                //全部为否或者一个为是，解除【下一步】按钮限制
                if (data.filter(d => (d.checked === false)).length === data.length || data.filter(d => (d.checked)).length >= 1) {
                    setNextBtnDisable(false);
                }
                else {
                    setNextBtnDisable(true);
                }
            }
            setDataSource([...data]);
        }
    }

    const columns = [
        {
            title: () => {
                return <div>{intl.get("1a025c89-dc18-28d2-8696-fc4900fd66ec")}</div>;
            },
            dataIndex: "sourceCode",
            width: 60,
            align: "center",
        },
        {
            title: () => {
                return (
                    //type==='dotsSearch' 不需要脱敏
                    <div>
                        {intl.get("Account_9c2bb8e4-91fa-2d8d-a5e9-40c10fe68de7")}
                    </div>
                );
            },
            dataIndex: "account",
        },
        {
            title: () => {
                return (
                    //type==='dotsSearch' 不需要脱敏
                    <div>
                        {intl.get("Supplier_Principal_Name_1dcb2f00-8880-20ad-af0e-b55700e09f3f")}
                    </div>
                );
            },
            dataIndex: "teamName",
        },
        {
            title: () => {
                return (
                    <div>
                        <span className="require">*</span>
                        {type === 'ad' ? intl.get("c873e651-652f-24d2-a110-72f6adb5775f") : (type === 'choose' ? intl.get("7a932853-72e4-2bdf-a4fb-83ec730034f4") : intl.get("3703bc9d-dd9d-260f-b6c2-09d6cf43f820"))}
                    </div>
                );
            },
            dataIndex: "choose",
            render: (_, record, index) => {
                if (type === 'ad') {
                    return <Select
                        value={record.checked}
                        onChange={(e) => handleAccountChanged(e, index)}
                        placeholder={intl.get('Please_select_354ba577-f942-298f-a717-0372712b1969')} >
                        <Option value={true}>{intl.get('Yes_87fddcb6-1cfa-2295-ae0f-b04062a4c122')}</Option>
                        <Option value={false}>{intl.get('No_055a24d6-5d33-2f3c-951d-033ea30c62d8')}</Option>
                    </Select>
                }
                else if (type === 'choose') {
                    return <Radio checked={record.selected} onChange={() => handleChooseEvent(record, index)} value={record.account}>{intl.get("Start_391701aa-c2f2-2069-90c4-f9007ef9f382")}</Radio>
                }
                return <Radio checked={record.checked} onChange={() => handleChooseEvent(record, index)} value={record.account}>{intl.get("b11c2f86-555c-297a-a68a-4d9aa2e1b61e")}</Radio>
            }
        }
    ];
    //检查弹窗取消按钮事件
    const onCancel = (values) => {
        setInputAccount('');
        setInputTeamName('');
        if (tipModalType === 'check' || tipModalType === 'checkLike') {
            setCheckResult(true);
            const data = dataSource;
            data[currentAccountIndex].checked = null;
            if (type === "ad") {
                //全部为否或者一个为是，解除【下一步】按钮限制
                if (data.filter(d => (d.checked === false)).length === data.length || data.filter(d => (d.checked)).length >= 1) {
                    setNextBtnDisable(false);
                }
                else {
                    setNextBtnDisable(true);
                }
            }
            if (type.indexOf('dots') !== -1) {
                if (data.filter(d => d.checked).length === 1) {
                    setNextBtnDisable(false);
                }
                else {
                    setNextBtnDisable(true);
                }
            }
            setDataSource([...data]);
        }
        setIsCheckModalVisible(false);

    };

    //检查弹窗确定按钮事件
    const onOk = () => {
        if ((tipModalType === 'check' || (tipModalType === 'checkLike' && inputTeamName)) && inputAccount) {
            const item = dataSource[currentAccountIndex];
            checkAccount(props.dataSource.bindId, {
                account: inputAccount,
                id: item.id,
                sourceCode: item.sourceCode,
                teamName: tipModalType === 'check' ? item.teamName : inputTeamName,
                searchType: item.searchType
            }).then(res => {
                if (res.code === 0) {
                    setCheckResult(true);
                    setInputAccount('');
                    setInputTeamName('');
                    if (type === 'ad') {
                        //ad模式下选择为本团队账号，且校验账号通过
                        const data = JSON.parse(JSON.stringify(dataSource));
                        data[currentAccountIndex] = res.data.filter(d => d.id === item.id).pop();
                        data[currentAccountIndex].checked = true;
                        data[currentAccountIndex].verify = true;
                        //全部为否或者一个为是，解除【下一步】按钮限制
                        if (data.filter(d => (d.checked === false)).length === data.length || data.filter(d => (d.checked)).length >= 1) {
                            setNextBtnDisable(false);
                        }
                        else {
                            setNextBtnDisable(true);
                        }
                        setDataSource(data);
                    }
                    if (type === 'dots' || type === 'dotsLike') {
                        //dots模式下选择为本团队账号，且校验账号通过
                        const data = JSON.parse(JSON.stringify(dataSource));
                        data[currentAccountIndex] = res.data.filter(d => d.id === item.id).pop();
                        data[currentAccountIndex].verify = true;
                        data.map((d, i) => {
                            if (i === currentAccountIndex) {
                                d.checked = true;
                            }
                            else {
                                d.checked = false;
                            }
                        });
                        if (data.filter(d => d.checked).length === 1) {
                            setNextBtnDisable(false);
                        } else {
                            setNextBtnDisable(true);
                        }
                        setDataSource(data);
                    }
                    setIsCheckModalVisible(false);
                    return;
                }
                else {
                    setCheckResult(false);
                    messageModal(res.message);
                    return;
                }
            });
        }
        else if (tipModalType === 'check' || tipModalType === 'checkLike') {
            setCheckResult(false);
            return;
        }
        //全部为否提示
        if (tipModalType === 'tips' && type === 'ad') {
            console.log('全部为否确定');
            activateAccount(props.dataSource.bindId, []).then(res => {
                if (res.code === 0) {
                    setIsCheckModalVisible(false);
                    props.confirm(res, 'active');
                }
                else {
                    messageModal(res.message);
                }
            });
            return;
        }
        if (tipModalType === 'search') {
            if (inputTeamName && inputAccount) {
                searchAccount(props.dataSource.bindId, {
                    account: inputAccount,
                    teamName: inputTeamName
                }).then(res => {
                    if (res.code === 0) {
                        if (res.data) {
                            setIsCheckModalVisible(false);
                            setDataSource([res.data]);
                            setNoSearchTips(false);
                            setType('dotsSearch');
                            setNextBtnDisable(true);
                            setInputAccount('');
                            setInputTeamName('');
                        }
                        else {
                            setNoSearchTips(true);
                        }
                    }
                    else {
                        messageModal(res.message);
                    }
                });
            }
            else {
                setNoSearchTips(true);
            }
            return;
        }
    };

    //启用账号确定按钮事件
    const onChooseOk = () => {
        console.log('启用账号确定事件');
        const data = JSON.parse(JSON.stringify(dataSource));
        data.map((item, index) => {
            if (index === currentAccountIndex) {
                item.activate = 1;
            }
            else {
                item.activate = 0;
            }
        });
        activateAccount(props.dataSource.bindId, data).then(res => {
            if (res.code === 0) {
                props.confirm(res, 'active');
            }
            else {
                messageModal(res.message);
            }
        });
    }

    //手动搜索团队关联按钮事件
    const searchTeam = () => {
        setTipModalType('search');
        setIsCheckModalVisible(true);
    };

    //注册团队按钮确定事件
    const registerTeam = () => {
        const registerData = regFormTeam.getFieldValue();
        if (registerData.isOverseas == 1) {
            registerData.phone = registerData.phoneEmail;
        } else {
            registerData.email = registerData.phoneEmail;
        }

        adRegist(props.dataSource.bindId, registerData).then((res) => {
            if (res.code === 0) {
                setIsRegisterModalVisible(false);
                closeModal();
                message.success(intl.get("198d09ea-d262-2ebe-a499-87ebdaf95903"));
                //  登录
                props.confirm({
                    username: registerData.phoneEmail,
                    password: registerData.password,
                }, 'register');
            } else {
                messageModal(res.message);
                return;
            }
        });
    };

    //账号选择下一步事件
    const handleNextBtnClick = () => {
        const dataList = dataSource.filter(data => data.checked);
        if (dataList.length === 0) {
            if (type === 'ad') {
                setTipModalType('tips');
                setIsCheckModalVisible(true);
                return;
            }
            else if (type.indexOf('dots') !== -1) {
                message.warning(intl.get('8c106043-3aaa-2965-8fc9-854c2e5f9068'));
                return;
            }
        }
        if (dataList.length > 1 && type === 'ad') {
            message.warning(intl.get('96c866d1-4355-2870-8478-c2ea504f0cb0'));
            return;
        }
        checkAccount(props.dataSource.bindId, dataList[0]).then(res => {
            if (res.code === 0) {
                props.chooseTeam({ bindId: props.dataSource.bindId, adTeamVos: res.data });
                return;
            }
            else {
                messageModal(res.message);
                return;
            }
        });
    }

    const renderTips = () => {
        if (type === 'ad') {
            return intl.get('115a3dbf-8b7a-2e99-8c7f-f6265a749b99');
        }
        if (type === 'dots') {
            return intl.get('d63d9c31-46e8-2269-bab9-a63dd0928e3b');
        }
        if (type === 'dotsLike') {
            return intl.get('dfd1a706-c993-27d6-bc50-1d88986b7f9c');
        }
        if (type === 'choose') {
            return intl.get('e2c5d82c-4d76-24d9-907f-b5abf8f6ac00');
        }
        return intl.get('3ebf243d-86fa-2e8f-8261-6cd21f905ea4');
    }
    const renderTipsContent = () => {
        if (tipModalType === 'tips') {
            return intl.get("df8a865d-7e97-2bfd-b348-71b38ff76378");
        }
        else if (tipModalType === 'check') {
            return <>
                <Row>
                    <Col span={6}>{type === 'ad' ? intl.get('c4995dae-9eab-2ecf-9359-7db956876022') : intl.get('255d66ed-4890-2375-b95d-548ab14c9855')}:</Col>
                    <Col span={18}>{dataSource[currentAccountIndex].account}</Col>
                </Row>
                <Row className="mT20">
                    <Col span={6}>{intl.get('8e50ad9d-d5ed-27a8-9508-84ac90d71846')}:</Col>
                    <Col span={18}><Input value={inputAccount} onChange={(e) => setInputAccount(e.target.value)} /></Col>
                </Row>
                {!checkResult && <Row className="require mT20">
                    <Col span={6}></Col>
                    <Col span={18}>{`${intl.get('Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16')}：${intl.get('106308ef-96a3-2092-87be-4035f9fdf6d5')}`}</Col>
                </Row>}
            </>
        }
        else if (tipModalType === 'checkLike') {
            return <>
                <Row>
                    <Col span={6}>{type === 'ad' ? intl.get('c4995dae-9eab-2ecf-9359-7db956876022') : intl.get('255d66ed-4890-2375-b95d-548ab14c9855')}:</Col>
                    <Col span={18}>{dataSource[currentAccountIndex].account}</Col>
                </Row>
                <Row className="mT20">
                    <Col span={6}>{intl.get('Supplier_Principal_Name_1dcb2f00-8880-20ad-af0e-b55700e09f3f')}:</Col>
                    <Col span={18}>{dataSource[currentAccountIndex].teamName}</Col>
                </Row>
                <Row className="mT20">
                    <Col span={6}>{intl.get('8e50ad9d-d5ed-27a8-9508-84ac90d71846')}:</Col>
                    <Col span={18}><Input value={inputAccount} onChange={(e) => setInputAccount(e.target.value)} /></Col>
                </Row>
                <Row className="mT20">
                    <Col span={6}>{intl.get('5f08b31f-0239-2e81-b779-1fd5eab03442')}:</Col>
                    <Col span={18}><Input value={inputTeamName} onChange={(e) => setInputTeamName(e.target.value)} /></Col>
                </Row>
                {!checkResult && <Row className="require mT20">
                    <Col span={6}></Col>
                    <Col span={18}>{`${intl.get('Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16')}：${intl.get('106308ef-96a3-2092-87be-4035f9fdf6d5')}`}</Col>
                </Row>}
            </>
        }
        else if (tipModalType === 'search') {
            return <>
                <Row>
                    <Col span={6}>{intl.get('Supplier_Principal_Name_1dcb2f00-8880-20ad-af0e-b55700e09f3f')}:</Col>
                    <Col span={18}><Input value={inputTeamName} onChange={(e) => setInputTeamName(e.target.value)} /></Col>
                </Row>
                <Row className="mT20">
                    <Col span={6}>{intl.get('55fe51d2-a838-26a5-94c3-8339f0e85de4')}:</Col>
                    <Col span={18}><Input value={inputAccount} onChange={(e) => setInputAccount(e.target.value)} /></Col>
                </Row>
                {noSearchTips && <Row className="require mT20">
                    <Col span={6}></Col>
                    <Col span={18}>{`${intl.get('Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16')}：${intl.get('41cec225-e330-275e-b373-52086d69b33b')}`}</Col>
                </Row>}
            </>
        }
        else {
            return <></>
        }
    }

    return (
        <>
            <Modal
                title={type === 'choose' ? intl.get("7a932853-72e4-2bdf-a4fb-83ec730034f4") : intl.get("c399f253-a8ce-2cd8-9d5e-11527165c4da")}
                visible={isTeamBindModal}
                width={650}
                maskClosable={false}
                // closable={false}
                onCancel={closeModal}
                footer={false}
            >
                {
                    type !== 'dotsSearch' && <div className="mT10 tips">
                        <ExclamationCircleFilled
                            style={{
                                padding: "4px",
                                color: "red",
                                borderRadius: "50%",
                            }}
                        />{renderTips()}
                    </div>
                }
                {type !== 'dotsNoResult' && <Table
                    rowKey="no"
                    columns={columns}
                    loading={loading}
                    dataSource={dataSource}
                    style={{ maxHeight: '500px', overflowY: 'auto' }}
                    bordered
                    pagination={false}
                />
                }
                <p className="mT10 m0 smallFize">
                    {intl.get("1738bad9-16da-2ce9-b63a-69052bf84d69")}
                </p>
                <Row style={{ justifyContent: "center", marginTop: 20 }}>
                    {type !== 'choose' && type !== 'dotsNoResult' &&
                        <Button
                            disabled={nextBtnDisable}
                            style={{ marginRight: 20 }}
                            type="primary"
                            onClick={handleNextBtnClick}>
                            {intl.get("Next_7d758f4b-5509-2946-b7a8-d61384998d77")}
                        </Button>
                    }
                    {type === 'choose' && <>
                        <Button type="primary" onClick={onChooseOk}>
                            {intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19")}
                        </Button>
                        <Button style={{ marginLeft: 20 }} onClick={closeModal}>
                            {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
                        </Button>
                    </>}
                    {type.indexOf('dots') !== -1 && <>
                        <Button type="primary" onClick={searchTeam}>
                            {intl.get("03d0edb2-a610-2d1f-9ea4-28a6c7e62866")}
                        </Button>
                        <Button style={{ marginLeft: 20 }} onClick={() => { regFormTeam.setFieldsValue({ phoneEmail: loginData.username }); setIsRegisterModalVisible(true); }}>
                            {intl.get("dcdf4a74-9f65-2657-bb0b-8a1f8999bd60")}
                        </Button>
                    </>}
                </Row>
            </Modal>
            <Modal
                visible={isCheckModalVisible}
                title={tipModalType === 'search' ? intl.get('73812012-d76a-28dd-925b-33cb96b35c0b') : intl.get('Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16')}
                footer={null}
                closable={false}
                maskClosable={false}
            >
                <div className="mT20">
                    {renderTipsContent()}
                </div>
                <Row style={{ justifyContent: "center", marginTop: 20 }}>
                    <Button type="primary" onClick={onOk}>
                        {intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19")}
                    </Button>
                    <Button style={{ marginLeft: 20 }} onClick={onCancel}>
                        {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
                    </Button>
                </Row>
            </Modal>
            <Modal
                visible={isRegisterModalVisible}
                title={intl.get('c7649d0a-30f3-2a5d-9c82-0327be964fd1')}
                footer={null}
                closable={false}
                maskClosable={false}
            >
                <div className="register-main">
                    <Form
                        form={regFormTeam}
                        name="basic"
                        onFinish={registerTeam}
                        autoComplete="off"
                        className="login-main"
                        initialValues={{ supplierType: 3, isOverseas: 1 }}
                        style={{ margin: "auto" }}
                        labelWrap
                        labelAlign="left"
                    >

                        <Form.Item
                            name="supplierType"
                            label={intl.get(
                                "Supplier_Type_fdfa220a-830f-274c-ab6e-d47d9dfa4f5f"
                            )}
                            className="special labelWidth"
                            rules={[{ required: true }]}
                        >
                            <Radio.Group onChange={(e) => setSupplierType(e.target.value)}>
                                <Radio value={3}>
                                    {intl.get(
                                        "Enterprise_Supplier_915e1fc2-552b-239e-be1d-3515a3e8ff8a"
                                    )}
                                </Radio>
                                <Radio value={1}>
                                    {intl.get(
                                        "Individual_Supplier_7250652a-f2df-294d-a15d-bac240bd8419"
                                    )}
                                </Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item
                            label={intl.get(
                                "Non-Chinese_Supplier_16f528b3-db1a-2a65-bb4e-2d3f2a57823e"
                            )}
                            className="special labelWidth"
                            name="isOverseas"
                            rules={[{ required: true }]}
                        >
                            <Radio.Group onChange={(e) => setIsOverseas(e.target.value)}>
                                <Radio value={1}>
                                    {intl.get("No_055a24d6-5d33-2f3c-951d-033ea30c62d8")}
                                </Radio>
                                <Radio value={2}>
                                    {intl.get("Yes_87fddcb6-1cfa-2295-ae0f-b04062a4c122")}
                                </Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item
                            name="supplierName"
                            label={intl.get(
                                "Supplier_Principal_Name_1dcb2f00-8880-20ad-af0e-b55700e09f3f"
                            )}
                            className="special"
                            rules={[
                                {
                                    required: true,
                                    message: intl.get("f3b463e6-398f-24ef-b440-30a129c295a1"),
                                },
                                {
                                    pattern: new RegExp(/^(?!\s)(?!.*\s$)/),
                                    message: intl.get(
                                        "Correct_274ca174-9cf3-270a-9a4f-91b9e00cf937_Correct"
                                    ),
                                },
                            ]}
                        >
                            <Input
                                maxLength={50}
                                size="large"
                                placeholder={
                                    supplierType === 3
                                        ? intl.get(
                                            "Name_513a9b27-a988-231e-8854-f308c98379f1_Name"
                                        )
                                        : intl.get(
                                            "Name_e72ab80b-c16b-25e0-9042-4916da225757_Name"
                                        )
                                }
                            />
                        </Form.Item>

                        <ErCode
                            inputDisabled
                            type={isOverseas}
                            isCheck={true}
                            // nextStep={nextStep}
                            isReg={true}
                            forms={regFormTeam}
                        />

                        <Form.Item
                            label={intl.get(
                                "Password_53aeeeeb-f4b2-2ec7-8378-0824b54674f2"
                            )}
                            name="password"
                            className="special"
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: intl.get(
                                        "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password"
                                    ),
                                },
                                {
                                    pattern: new RegExp(
                                        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
                                    ),
                                    message: intl.get(
                                        "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb"
                                    ),
                                },
                            ]}
                        >
                            <Input.Password
                                size="large"
                                autoComplete="new-password"
                                placeholder={intl.get(
                                    "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb"
                                )}
                            />
                        </Form.Item>

                        <Form.Item
                            label={intl.get(
                                "Confirm_password_c11a821c-0a36-263d-a77a-30097899f35e"
                            )}
                            name="passwordConfirm"
                            className="special"
                            dependencies={["password"]}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: intl.get(
                                        "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password"
                                    ),
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue("password") === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(
                                                intl.get(
                                                    "The_passwords_entered_twice_do_not_match_8613bcda-26a3-2814-95fc-027239abaee3"
                                                )
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                size="large"
                                placeholder={intl.get(
                                    "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb"
                                )}
                            />
                        </Form.Item>
                        <Form.Item className="login-btn">
                            <Row style={{ justifyContent: "center", marginTop: 20 }}>
                                <Button style={{ width: 60 }} type="primary" htmlType="submit">
                                    {intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19")}
                                </Button>
                                <Button style={{ marginLeft: 20 }} onClick={() => setIsRegisterModalVisible(false)}>
                                    {intl.get("39a30fd0-7135-264f-941d-adca9af6b14a")}
                                </Button>
                            </Row>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
}
